<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h2 class="text-white">Events</h2>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Home</a>
                        </li>/
                        <li class="active">
                            <a href="javascript:void(0);">Events</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="circle-gradient overflow-hidden section-lg horizontal-tabs">
    <div class="container">
        <ul class="nav nav-pills justify-content-center flex-row" id="myTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link text-center active" id="cultural-tab" data-bs-toggle="tab" href="#cultural"
                    role="tab" aria-controls="cultural" aria-selected="true">Cultural</a>
            </li>
            <li class="nav-item">

                <a class="nav-link text-center " id="academic-tab" data-bs-toggle="tab" href="#academic" role="tab"
                    aria-controls="academic" aria-selected="false">Academic</a>

            </li>
            <li class="nav-item">

                <a class="nav-link text-center " id="sports-tab" data-bs-toggle="tab" href="#sports" role="tab"
                    aria-controls="sports" aria-selected="false">Sports</a>

            </li>
            <li class="nav-item">

                <a class="nav-link text-center " id="conferences-tab" data-bs-toggle="tab" href="#conferences"
                    role="tab" aria-controls="conferences" aria-selected="false">Conferences
                </a>

            </li>
            <li class="nav-item">

                <a class="nav-link text-center " id="technical-tab" data-bs-toggle="tab" href="#technical" role="tab"
                    aria-controls="technical" aria-selected="false">Technical
                </a>

            </li>
            <li class="nav-item">

                <a class="nav-link text-center " id="workshops-tab" data-bs-toggle="tab" href="#workshops" role="tab"
                    aria-controls="workshops" aria-selected="false">Workshops &amp; Seminars
                </a>

            </li>
            <li class="nav-item">
                <a class="nav-link text-center " id="convocation-tab" data-bs-toggle="tab" href="#convocation"
                    role="tab" aria-controls="convocation" aria-selected="false">Convocation Ceremony
                </a>
            </li>
        </ul>
        <div class="tab-content mt-5" id="myTabContent">
            <div class="tab-pane fade show active" id="cultural" role="tabpanel" aria-labelledby="cultural-tab">
                <div class="sec-title text-center mb-5" data-aos="zoom-in">
                    <h2>Cultural Events</h2>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Farewell Party</span>
                                    </h2>
                                </div>
                                <p>"A truly unforgettable event.
                                    Celebrating journeys, friendships, and dreams, as our students step confidently into
                                    a future full of possibilities."</p>
                                <div class=" text-lg-start">
                                    <a href="farewell-party" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-1.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center  flex-row-reverse g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Women Empowerment</span>
                                    </h2>
                                </div>
                                <p>GHRCACS Pune conducted a guest lecture on women empowerment and health, delivered by
                                    esteemed guest Mrs. Pradnya Kulkarni.</p>
                                <div class=" text-lg-start">
                                    <a href="women-empowerment" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/women-empowermen1.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center  g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Gurupornima Celebration</span>
                                    </h2>
                                </div>
                                <p>GHRCACS celebrate Gurupornima on 10th July 2025.</p>
                                <p>On this Guru Purnima, GHRCACS Pune celebrated the guiding lights who shape minds and
                                    inspire journeys.
                                    A heartfelt tribute to the mentors who make learning meaningful</p>
                                <div class=" text-lg-start">
                                    <a href="guru-purnima" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima2.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Ashadhi Ekadashi Celebration</span>
                                    </h2>
                                </div>
                                <p>Joyful Celebrations at GHRCACS Pune on Ashadhi Ekadashi!

                                    From heartfelt performances and captivating speeches to vibrant dances and
                                    traditional rituals, our students and faculty embraced the spirit of devotion,
                                    discipline, and unity. Here's a glimpse into our wonderful day filled with smiles,
                                    culture, and cherished moments!</p>
                                <div class=" text-lg-start">
                                    <a href="ashadhi-ekadashi" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi2.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center  g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Student Achievement-Pune kala sanskrutik Mohotsav 2025</span>
                                    </h2>
                                </div>
                                <p>Students from GHRCACS Pune participated in the Pune Kala Sanskrutik Mahotsav 2025,
                                    organized by Pratham Shikshan Mandal, Pune, and won a prize.

                                </p>
                                <div class=" text-lg-start">
                                    <a href="sanskrutik-mohotsav" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/event/ghrcacs-sanskrutik-3.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Shivaji maharaj Jayanti 2025</span>
                                    </h2>
                                </div>
                                <p>GHRCACS proudly celebrated Chhatrapati Shivaji Maharaj Jayanti, honoring the legacy
                                    and bravery of the great Maratha warrior.</p>
                                <div class="text-lg-start">
                                    <a href="shivaji-maharaj-jayanti" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/shivaji-maharaj-jayanti-4.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center  g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span> मराठी राजभाषा दिन</span>
                                    </h2>
                                </div>
                                <p>GHRCACS Pune proudly celebrated मराठी राजभाषा दिन, honoring the richness, heritage,
                                    and pride of the Marathi language.

                                </p>
                                <div class="text-lg-start">
                                    <a href="marathi-rajbhasha" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-5.avif"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>

                <!-- <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Dr. Babasaheb Ambedkar Mahaparinirvan Diwas</span>
                                    </h2>
                                </div>
                                <p>2024-25</p>
                                <div class=" text-lg-start">
                                    <a href="mahaparinirvan-diwas" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/maparivahan-day.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div> -->
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center  flex-row-reverse g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Antaragni</span>
                                    </h2>
                                </div>
                                <p>Lights. Colors. Culture. ✨ Antaragni Days brought out the vibrant spirit of GHRCACS
                                    Pune — from traditional grace to modern grooves!</p>
                                <div class="text-lg-start">
                                    <a href="antaragni" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center  g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Farewell Function and Annual Prize Distribution 2025</span>
                                    </h2>
                                </div>
                                <p>Bidding Adieu with Pride and Gratitude! GHRCEM Pune celebrated its Farewell Function
                                    & Annual Prize Distribution 2025 with heartfelt memories, proud moments, and
                                    applause-worthy achievements.</p>
                                <div class="text-lg-start">
                                    <a href="annual-prize-distribution" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function-aanual-prize-1.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="workshops" role="tabpanel" aria-labelledby="workshops-tab">
                <div class="sec-title text-center mb-5" data-aos="zoom-in">
                    <h2>Workshops &amp; Seminars</h2>
                </div>
                <!-- <div class="bg-white border-radius-sec  mb-lg-5">
                    <div class="row align-items-center  g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5 p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Digital Marketing in Action:A project Based Workshop</span></h2>
                                </div>
                                <p>Department of Computer Application and Business Administration, GHRCACS,Pune
                                    organized a Guest lecturer on " Digital Marketing in Action:A project Based
                                    Workshop" on Thursday 26th September and Friday 27th September 2025, at Seminar Hall
                                    at 10:00am to 2:00pm.</p>
                                <div class="text-lg-start">
                                    <a href="digital-marketing-workshop" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-3.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div> -->
                <div class="bg-white border-radius-sec  mb-lg-5">
                    <div class="row align-items-center flex-row-reverse  g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5 p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Industry Connect 2025</span>
                                    </h2>
                                </div>
                                <p>T & P III, GHRCACS organised a one-day workshop titled "Industry Connect 2025 |
                                    GHRCACS, PUNE", an
                                    Internship &
                                    On-the-Job Training Awareness Program, being organized in association with
                                    Savitribai
                                    Phule Pune
                                    University on 19th July 2025 at seminar hall.</p>
                                <div class="text-lg-start">
                                    <a href="industry-connect" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/industry-connect5.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec  mb-lg-5">
                    <div class="row align-items-center  g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5 p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Business Expo(BBA dept)</span>
                                    </h2>
                                </div>
                                <p>Department of BBA GHRCACS,Pune organised Business Expo 2025.</p>


                                <div class="text-lg-start">
                                    <a href="business-expo" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/business-expo-bba-dept-4.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="academic" role="tabpanel" aria-labelledby="academic-tab">
                <div class="sec-title text-center mb-5" data-aos="zoom-in">
                    <h2>Academic Events</h2>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1">
                        <div class="col">
                            <div class="px-lg-5 p-3">
                                <div class="sec-title mb-3">
                                    <h2><span>Guest lecturer on Anti Ragging</span></h2>
                                </div>
                                <p>GHRCACS,Pune organized a Guest lecturer on "Anti Ragging" on Wednesday 1st October
                                    2025, at Seminar Hall at 10:00am to 2:00pm.</p>
                                <div class="text-lg-start">
                                    <a href="anti-ragging-event" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/anti-ragging/anti-ragging-1.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center g-0 row-cols-md-2 row-cols-1">
                        <div class="col">
                            <div class="px-lg-5 p-3">
                                <div class="sec-title mb-3">
                                    <h2><span>Guest lecturer on Gender Sensitization</span></h2>
                                </div>
                                <p>Computer Science department, GHRCACS,Pune organized a Guest lecturer on Gender
                                    Sensitization on Wednesday24th September 2025.</p>
                                <div class="text-lg-start">
                                    <a href="guest-lecturer" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guest-lecturer/guest-lecturer-1.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1">
                        <div class="col">
                            <div class="px-lg-5 p-3">
                                <div class="sec-title mb-3">
                                    <h2><span>Cynosure (Raisoni ACE Toastmasters Club)</span></h2>
                                </div>
                                <p>At GHRCEM Pune's CYNOSURE 2025, the stage belonged to our young leaders. Through
                                    powerful words, poised presence, and the spirit of teamwork, they embodied what
                                    Toastmasters is all about — confidence in communication and strength in leadership.
                                </p>
                                <div class="text-lg-start">
                                    <a href="cynosure-toastmasters" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/cynosure-toastmasters/cynosure-toastmasters.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center g-0 row-cols-md-2 row-cols-1">
                        <div class="col">
                            <div class="px-lg-5 p-3">
                                <div class="sec-title mb-3">
                                    <h2><span>Punyatithi of Saahitya Ratna Annabhau Sathe</span></h2>
                                </div>
                                <p>GHRCACS observed the Punyatithi of Saahitya Ratna Annabhau Sathe on Friday, 18th July
                                    2025 </p>
                                <div class="text-lg-start">
                                    <a href="punyatithi-of-annabhau-sathe" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna1.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>

                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1">
                        <div class="col">
                            <div class="px-lg-5 p-3">
                                <div class="sec-title mb-3">
                                    <h2><span>Founder's Day</span></h2>
                                </div>
                                <p>GHRCACS celebrated Founder's Day by organizing a Debate Competition for students on
                                    30th June 2025. </p>
                                <div class=" text-lg-start">
                                    <a href="founders-day" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/founder-day25.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center g-0 row-cols-md-2 row-cols-1">
                        <div class="col">
                            <div class="px-lg-5 p-3">
                                <div class="sec-title mb-3">
                                    <h2><span>Celebration of Yoga day 2025</span></h2>
                                </div>
                                <p>GHRCACS, Pune celebrated International Yoga Day 2025 on 21st June 2025.</p>
                                <div class="text-lg-start">
                                    <a href="celebrating-yoga-day" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/cele-yoda-d.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="conferences" role="tabpanel" aria-labelledby="conferences-tab">
                <div class="sec-title text-center mb-5" data-aos="zoom-in">
                    <h2>Conferences</h2>
                </div>
                <div class="bg-white border-radius-sec  mb-lg-5">
                    <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5 p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>GB Meeting</span>
                                    </h2>
                                </div>
                                <p>GHRCACS Pune held its Governing Body Meeting on 20th Jan 2025, addressing key
                                    academic, financial, and administrative decisions for institutional growth.</p>
                                <div class="text-lg-start">
                                    <a href="gb-meeting" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-1.webp"
                                class="w-100" alt="event | Raisoni Education">
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="technical" role="tabpanel" aria-labelledby="technical-tab">
                <div class="sec-title text-center mb-5" data-aos="zoom-in">
                    <h2>Technical</h2>
                </div>
                <div class="bg-white border-radius-sec  mb-lg-5">
                    <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5 p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Science Day</span>
                                    </h2>
                                </div>
                                <p> GHRCACS,Pune organised a National Science Day 2025 at seminar hall.</p>
                                <div class="text-lg-start">
                                    <a href="science-day" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-2.webp"
                                class="w-100" alt="event | Raisoni Education">
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-sec  mb-lg-5">
                    <div class="row align-items-center g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5 p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>CodeRush@Raisoni 2K25 competition</span>
                                    </h2>
                                </div>
                                <p>GHRCACS Pune's CodeRush (24th-25th Feb 2025) brought together coding enthusiasts for
                                    a battle of skills, featuring competitions, problem-solving, and innovation!</p>
                                <div class="text-lg-start">
                                    <a href="coderush" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/code-rush-6.webp"
                                class="w-100" alt="event | Raisoni Education">
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="sports" role="tabpanel" aria-labelledby="sports-tab">
                <div class="sec-title text-center mb-5" data-aos="zoom-in">
                    <h2>Sports Events</h2>
                </div>
                <div class="bg-white border-radius-sec  mb-lg-5">
                    <div class="row align-items-center  flex-row-reverse g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5 p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>NSS CAMP 2025</span>
                                    </h2>
                                </div>
                                <p>The G H Raisoni College of Arts, Commerce and Science Wagholi
                                    successfully organized a 07-days NSS (National Service Scheme) camp at Awahalwadi
                                    from
                                    10/02/2025 to 16/02/2025 The camp aimed to instil a spirit of service, leadership,
                                    and
                                    community engagement among the volunteers.</p>
                                <div class=" text-lg-start">
                                    <a href="nss-camp" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img loading="lazy"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-1.webp"
                                class="w-100" alt="EVENTS | GHRCACS, PUNE">
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="convocation" role="tabpanel" aria-labelledby="convocation-tab">
                <div class="sec-title text-center mb-5" data-aos="zoom-in">
                    <h2>No Events</h2>
                </div>
            </div>
        </div>
    </div>
</section>
